import SliceManager from 'components/shared/SliceManager'
import { getDataDependencies } from 'services/api'
import ComparatorsGrid from 'src/components/pages/comparators/ComparatorsGrid'
import ComparatorsIntro from 'src/components/pages/comparators/ComparatorsIntro'
import { fetchComparators} from 'src/services/api'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

import PreviewBanner from 'components/shared/PreviewBanner'

import css from './styles.module.scss'


const Comparators = ({
  comparators,
  pageData: { slices, title, description, label },
  preview
}) => {
  return (
    <div className={css.container}>
      {preview && <PreviewBanner />}
      <div className={css.mainSection}>
        <ComparatorsIntro label={label} title={title} subTitle={description} />
        {comparators && <ComparatorsGrid comparators={comparators} />}
      </div>
      {slices && <SliceManager slices={slices} />}
    </div>
  )
}

export async function getStaticProps({ preview = null }) {
  const json = await fetchSingleType('comparators-home', preview)
  const comparators = await fetchComparators()
  const pageData = await getDataDependencies(json)
  return {
    props: {
      comparators,
      pageData,
      preview
    },
  }
}

export default Comparators
